import React, { useState } from "react";
import CommonModal from "./CommonModal";
import { TextField, Typography } from "@mui/material";
import closeIcon from "../../assets/close-icon.svg";
import "./staffobservation.scss";
import { setLoading } from "../state/action/globalAction";
import { useDispatch } from "react-redux";
import { addComments } from "../../services/romReports";
import { getParams } from "../../utils/helpers";
import MessagePopup from "./MessagePopup";
import { pageLocale } from "../../utils/locale";

const PatientRemark = ({ patientRemark, setPatientRemark, reportIDData }) => {
  const [patient, setPatient] = useState("");
  const [messagePopup, setMessagePopup] = useState(false);

  const { reportId, moduleId } = getParams();
  const request = {
    patientRemarks: patient,
    moduleId: Number(moduleId),
  };

  const reportIDHandler = () => {
    if (reportId && reportId !== "latest") {
      return reportId;
    }
    return reportIDData || "latest";
  };
  const dispatch = useDispatch();
  const patientRemarkhandler = () => {
    dispatch(setLoading(true));
    addComments(request, reportIDHandler())
      .then(() => {
        dispatch(setLoading(false));
        setPatientRemark(patient);
        setMessagePopup(true);
      })
      .catch(() => {
        dispatch(setLoading(false));
        setPatientRemark();
      });
  };
  const {
    test_person_remarks,
    done,
    patient_remarks_message,
    enter_here,
    max_limit,
  } = pageLocale("newreport");
  return (
    <>
      <CommonModal
        open={patientRemark}
        onClose={() => setPatientRemark()}
        className="staff-outer-wrapper"
      >
        <div className="staff-main-wrapper">
          <div className="staff-header">
            <Typography className="title">{test_person_remarks}</Typography>
            <img
              src={closeIcon}
              alt="close"
              onClick={() => setPatientRemark()}
            />
          </div>
          <TextField
            label={enter_here}
            multiline
            rows={4}
            inputProps={{ maxLength: 120 }}
            helperText={max_limit.replace("@@", "120")}
            className="text-box"
            value={patient}
            onChange={(e) => setPatient(e.target.value)}
          />
          <button
            className="done-btn"
            onClick={() => patientRemarkhandler()}
            disabled={patient.trim() === ""}
          >
            {done}
          </button>
        </div>
      </CommonModal>
      <MessagePopup
        messagePopup={messagePopup}
        setMessagePopup={setMessagePopup}
        text={patient_remarks_message}
      />
    </>
  );
};

export default PatientRemark;
